import Vue from 'vue';

const TemplateEventBus = new Vue();
export default TemplateEventBus;
